import { Stack, Typography } from '@mui/material';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks/useSourcingInternalStore';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { sourcingInternalStepComponents } from '../step-components/sourcingInternalStepComponents';
import { useGetCandidateBatchQuery } from 'generated-graphql/hooks/apollo-hooks';

type SourcingInternalStoreComponentProps = {
  sessionId: string;
  initialCandidateBatchId: string | undefined;
};

export const SourcingInternalStoreComponent: React.FC<
  SourcingInternalStoreComponentProps
> = (props) => {
  const organizationConfig = useOrganizationConfig();

  const { step, onInit } = useSourcingInternalStore(
    useShallow((state) => ({
      step: state.step,
      onInit: state.onInit
    }))
  );

  const { data: candidateBatchData } = useGetCandidateBatchQuery({
    variables: {
      id: props.initialCandidateBatchId || ''
    },
    skip: !props.initialCandidateBatchId
  });

  // When props change, initialize the store from scratch
  useEffect(() => {
    if (!props.initialCandidateBatchId) {
      onInit({
        sessionId: props.sessionId,
        candidateBatch: null
      });
      return;
    }

    if (candidateBatchData?.getCandidateBatch) {
      onInit({
        sessionId: props.sessionId,
        candidateBatch: candidateBatchData?.getCandidateBatch
      });
    }
  }, [
    props.sessionId,
    props.initialCandidateBatchId,
    candidateBatchData?.getCandidateBatch?.id
  ]);

  if (!organizationConfig?.internalSourcingEnabled) {
    return (
      <Stack alignItems="center" justifyContent="center" height="100%">
        <Typography variant="heading">
          Sourcing is not enabled for this organization
        </Typography>
        <Typography variant="default">
          Please contact your administrator to enable sourcing.
        </Typography>
      </Stack>
    );
  }

  const Content = sourcingInternalStepComponents[step];

  return (
    <Stack>
      <Content />
    </Stack>
  );
};
